const pageSize: number = 8;

export default pageSize;
